import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../../providers/notification-provider';
import { Button } from './button';
import { cn } from '../../lib/utils';
import { NotificationDropdown } from './notification-dropdown';

export const NotificationBell: React.FC = () => {
  const { unreadCount } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleDropdown}
        className="relative"
        aria-label={`${unreadCount} unread notifications`}
      >
        <Bell className="h-5 w-5" />
        {unreadCount > 0 && (
          <span 
            className={cn(
              "absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center",
              "rounded-full bg-primary text-[10px] font-medium text-primary-foreground",
              unreadCount > 9 ? "text-[8px]" : ""
            )}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </Button>
      
      {isOpen && (
        <NotificationDropdown onClose={closeDropdown} />
      )}
    </div>
  );
}; 